
import { Loading, Notification } from 'element-ui'
import axios from 'axios'
import qs from 'qs'

// axios.interceptors.request.use(config => {
//   if (config.method == 'post') {
//     config.data = {
//       data: config.data,
//       _t: Date.parse(new Date().getTime()) / 1000
//     }
//   } else if (config.method == 'get') {
//     config.params = {
//       _t: Date.parse(new Date().getTime()) / 1000,
//       ...config.params
//     }
//   }
//   return config
// })

axios.interceptors.response.use(function(response) {
  if(response.data.status === false) {
    Notification.error({title: '错误', message: response.data.remark, duration: 3000})
  }
  // 对响应数据做点什么
  return response;
}, function(err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)';
        break;
      case 401:
        err.message = '未授权，请重新登录(401)';
        break;
      case 403:
        err.message = '拒绝访问(403)';
        break;
      case 404:
        err.message = '请求出错(404)';
        break;
      case 408:
        err.message = '请求超时(408)';
        break;
      case 500:
        err.message = '服务器错误(500)';
        break;
      case 501:
        err.message = '服务未实现(501)';
        break;
      case 502:
        err.message = '网络错误(502)';
        break;
      case 503:
        err.message = '服务不可用(503)';
        break;
      case 504:
        err.message = '网络超时(504)';
        break;
      case 505:
        err.message = 'HTTP版本不受支持(505)';
        break;
      default:
        err.message = `连接出错(${err.response.status})!`;
    }
  } else {
    err.message = '连接服务器失败!'
  }
  Notification.error({title: '错误', message: err.message, duration: 0})
  return Promise.reject(err);
});

// 广告主客户列表查询
export function GetAdvertiserList (params) {
  let loadingInstance = Loading.service({
    text: '加载中,请稍后...'
  })
  return axios.get(`/iad_customer/ListGGZ?_t=${new Date().getTime()}`, {params:params})
  .then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    loadingInstance.close()
    return Promise.reject(err)
  })
}
// 广告主客户列表审核通过、拒绝
export function CheckUser (params) {
  let loadingInstance = Loading.service({
    text: '处理中,请稍后...'
  })
  return axios.post(`/IAD_Customer/CheckUser?_t=${new Date().getTime()}`, params)
  .then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    loadingInstance.close()
    return Promise.reject(err)
  })
}
// 广告主充值申请

export function IadAdrRecharge (params) {
  let loadingInstance = Loading.service({
    text: '处理中,请稍后...'
  })
  return axios.post(`/IadAdrRecharge/Add?_t=${new Date().getTime()}`, params)
  .then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    loadingInstance.close()
    return Promise.reject(err)
  })
}

// 广告主退款申请

export function RefundShowSubmit (params) {
  let loadingInstance = Loading.service({
    text: '处理中,请稍后...'
  })
  return axios.post(`/IadFinanceReFun/RefundShowSubmit?_t=${new Date().getTime()}`, params)
  .then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    loadingInstance.close()
    return Promise.reject(err)
  })
}

// 退款申请接口显示数据

export function RefundShow (params) {
  return axios.post(`/IadFinanceReFun/RefundShow?_t=${new Date().getTime()}`, params)
    .then(res => {
      return Promise.resolve(res.data)
    }).catch(err => {
      return Promise.reject(err)
    })
}


// 上传打款凭证
export function uploadImg(file) {
  let param = new FormData()
  param.append('file', file, file.name)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }

  let loadingInstance = Loading.service({
    text: '上传中,请稍后...'
  })
  return axios.post(`/IAD_PutOn/UploadImg?_t=${new Date().getTime()}`, param, config).then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  })
}


// 获取销售列表
export function GetSalesman () {
  return axios.get(`/IAD_Customer/GetSalesman?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取运营列表
export function GetUserAdOperatorUser () {
  return axios.get(`/IAD_Customer/GetUserAdOperatorUser?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取广告主列表
export function GetUser (params) {
  return axios.get(`/iad_customer/getuser?_t=${new Date().getTime()}`, {params:params}).then(res => {
    return Promise.resolve(res.data)
  })
}

// 根据广告主获取最后一次选择的票据类型
export function GetInvoiceTypeByUserId (params) {
  return axios.get(`/IadAdrRecharge/GetInvoiceTypeByUserId?_t=${new Date().getTime()}`, {params:params}).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取广告主客户权限


export function GetUserRoleList () {
  return axios.get(`/IAD_Customer/GetUserRoleList?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/advertiser.js